import { isAxiosError } from "axios"

import { ApiError } from "@/api/client/_shared"

/**
 * The backend answers tender 4xx responses with a user-facing message in
 * `{ error: "..." }` (e.g. the 409 "Sammanfattningen är inte klar ännu …" from
 * the summary readiness gate). Tender code reaches the API through two clients:
 * the axios instance in `@/lib/api-client` (rejects with an AxiosError whose
 * `response.data` is that body) and the fetch helpers in `@/api/client`
 * (throw `ApiError` with the body's text in `bodyError`). Read the message from
 * either shape so dialogs can show the real reason instead of a generic
 * fallback.
 */
export function serverErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof ApiError && error.bodyError) return error.bodyError
  if (isAxiosError(error)) {
    const body: unknown = error.response?.data
    if (
      body &&
      typeof body === "object" &&
      typeof (body as { error?: unknown }).error === "string"
    ) {
      return (body as { error: string }).error
    }
  }
  return fallback
}
